import React, { useState, useEffect, createContext, useContext } from "react";

// Create a context for mobile-specific data
const MobileContext = createContext(null);

export const useMobile = () => {
  const context = useContext(MobileContext);
  if (!context) {
    throw new Error("useMobile must be used within a MobileOptimized provider");
  }
  return context;
};

const MobileOptimized = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [orientation, setOrientation] = useState("portrait");
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      // Set CSS variable for viewport height to fix 100vh on mobile
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);

      setIsMobile(window.innerWidth < 768);
      setOrientation(
        window.innerHeight > window.innerWidth ? "portrait" : "landscape",
      );
      setIsTouchDevice(
        "ontouchstart" in window || navigator.maxTouchPoints > 0,
      );
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    window.addEventListener("orientationchange", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
      window.removeEventListener("orientationchange", checkDevice);
    };
  }, []);

  const mobileContextValue = {
    isMobile,
    orientation,
    isTouchDevice,
  };

  return (
    <MobileContext.Provider value={mobileContextValue}>
      <div
        className={`min-h-screen ${isMobile ? "mobile-optimized" : "desktop-optimized"}`}
        data-is-mobile={isMobile}
        data-orientation={orientation}
        data-is-touch={isTouchDevice}
        style={{ minHeight: "calc(var(--vh, 1vh) * 100)" }}
      >
        {children}
      </div>
    </MobileContext.Provider>
  );
};

export default MobileOptimized;
